import { KeyDict } from '@/types'
import { GlobalAccelerator } from '@/types/ops'
import Vue from 'vue'

export default Vue.extend({
  mounted () {
    this.$store.direct.dispatch.opsmonitor.subscribeGlobalAccelerator()
  },
  beforeDestroy () {
    this.$store.direct.dispatch.opsmonitor.unsubscribeGlobalAccelerator()
  },
  computed: {
    globalAccelerator (): GlobalAccelerator {
      return this.$store.direct.state.opsmonitor.globalAccelerator
    },
    acceleratorMapping (): KeyDict<string> {
      return this.globalAccelerator.mapping
    }
  }

})
